import * as React from 'react';
import { translate } from 'components/translate-hoc';
import { ILoginPopupProps } from 'modules/login/login.types';

import Button from 'components/button';
import Spinner from 'components/spinner/spinner.component';

import { STYLES, TEXT_KEYS } from '../login.constants';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
import ubisoftOverlayService from 'modules/ubisoft-overlay-service/service';
import { getModeClass } from 'utils/css';
import { LOGIN_FLOW_STEP, LOGIN_FLOW_ACTIONS } from '../login.constants';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export class LoginPopup extends React.Component<ILoginPopupProps> {
    private handleLoginClick = () => {
        AnalyticsService.sendFlowEvent({
            ...LOGIN_FLOW_STEP,
            action: LOGIN_FLOW_ACTIONS.LOGIN,
            category: CATEGORY.ACTION
        });
        ubisoftOverlayService.openLoginPopup();
    };

    private renderLoginButton(): JSX.Element {
        const {
            fetching,
            loginSession,
            shouldInheritStyles,
            originalTranslateKey: translateKey
        } = this.props;
        if (!fetching && !loginSession) {
            return <Button
                type="primary"
                shouldInheritStyles={shouldInheritStyles}
                onClick={this.handleLoginClick}><span>{translateKey(TEXT_KEYS.BUTTON_LOGIN)}</span></Button>;
        }
        return <Spinner/>;
    }

    public render(): JSX.Element {
        return (
            <div className={getModeClass(STYLES.CONTENT, this.props.shouldInheritStyles)}>
                {this.renderLoginButton()}
            </div>
        );
    }
}

export default translate()(LoginPopup);
